import { useCart, useNotification } from '@/containers'
import { Dialog, Transition } from '@headlessui/react'
import Link from 'next/link'
import { Fragment } from 'react'

const ModalBuyNow = () => {
  const {
    selectedProductBuyNow,
    setSelectedProductBuyNow,
    setIsOpenBuyNow,
    isOpenBuyNow,
  } = useCart()
  const { systemConfig } = useNotification()
  return (
    <Transition appear show={isOpenBuyNow} as={Fragment}>
      <Dialog
        as='div'
        onClose={() => {
          setIsOpenBuyNow(false)
          setSelectedProductBuyNow('')
        }}
        className='relative z-[9999]'
      >
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-200'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bottom-0 left-0 z-[9999] bg-dark-900/60 transition-opacity' />
        </Transition.Child>
        <div className='fixed inset-0 z-[9999] overflow-y-auto'>
          <div className='flex min-h-full items-center justify-center p-4 text-center'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-200'
              enterFrom='opacity-0 scale-50'
              enterTo='opacity-100 scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 scale-100'
              leaveTo='opacity-0 scale-50'
            >
              <Dialog.Panel className='w-full max-w-[400px] transform overflow-hidden rounded-lg bg-white px-2 py-3 text-left align-middle transition-all'>
                <h3 className='mt-3 text-center text-base font-bold uppercase text-dark-900'>
                  lIÊN HỆ MUA NGAY SẢN PHẨM
                </h3>
                {
                  <div
                    onClick={() => {
                      setIsOpenBuyNow(false)
                      setSelectedProductBuyNow('')
                    }}
                    className='absolute right-1 top-2 flex cursor-pointer items-center gap-1'
                  >
                    <svg
                      width='24'
                      height='24'
                      viewBox='0 0 51 50'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <circle cx='25.5957' cy='25' r='25' fill='black' />
                      <g clip-path='url(#clip0_19560_66822)'>
                        <path
                          d='M31.8226 34.3527L25.5957 28.1257L19.3688 34.3527C18.5056 35.2158 17.1062 35.2158 16.243 34.3527C15.3799 33.4895 15.3799 32.0901 16.243 31.2269L22.47 25L16.243 18.7731C15.3799 17.9099 15.3799 16.5105 16.243 15.6473C17.1062 14.7842 18.5056 14.7842 19.3688 15.6473L25.5957 21.8743L31.8226 15.6473C32.6858 14.7842 34.0852 14.7842 34.9484 15.6473C35.8115 16.5105 35.8115 17.9099 34.9484 18.7731L28.7214 25L34.9484 31.2269C35.8115 32.0901 35.8115 33.4895 34.9484 34.3527C34.0852 35.2158 32.6858 35.2158 31.8226 34.3527Z'
                          fill='white'
                        />
                      </g>
                      <defs>
                        <clipPath id='clip0_19560_66822'>
                          <rect
                            width='20'
                            height='20'
                            fill='white'
                            transform='translate(15.5957 15)'
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                }
                <div className='listLocation border-grey-100 flex h-full flex-col items-center justify-center overflow-scroll px-1 scrollbar-hide'>
                  <p className='mt-5 text-left text-[13px] italic leading-snug text-dark-400'>
                    Liên hệ với Điện máy kho mua ngay sản phẩm
                    {selectedProductBuyNow} với giá tốt nhất.
                  </p>
                  <ul className='mt-5 grid w-full gap-2'>
                    <li className='flex h-10 w-full cursor-pointer items-center justify-center rounded bg-primary-base text-xs font-semibold text-white-400'>
                      <Link
                        href='tel:0904881179'
                        className='flex h-full w-full items-center justify-center'
                      >
                        GỌI 0904 88 11 79
                      </Link>
                    </li>
                    <li className='h-10 w-full cursor-pointer rounded bg-primary-base text-xs font-semibold text-white-400'>
                      <Link
                        href={systemConfig?.warehouseFacebook || '/'}
                        className='flex h-full w-full items-center justify-center'
                      >
                        CHAT QUA FACEBOOK
                      </Link>
                    </li>
                    <li className='flex h-10 w-full cursor-pointer items-center justify-center rounded bg-primary-base text-xs font-semibold text-white-400'>
                      <Link
                        href={systemConfig?.warehouseZalo || '/'}
                        className='flex h-full w-full items-center justify-center'
                      >
                        CHAT QUA ZALO
                      </Link>
                    </li>
                  </ul>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
export default ModalBuyNow
